import { render, staticRenderFns } from "./SinisterNotes.vue?vue&type=template&id=34fc4cbc&scoped=true"
import script from "./SinisterNotes.vue?vue&type=script&lang=ts"
export * from "./SinisterNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc4cbc",
  null
  
)

export default component.exports